import { Check, Phone } from "lucide-react";
import { LOANS, PHONE_DISPLAY, TEL_LINK, WA_LINK } from "@/lib/site";
import { Eyebrow, Reveal } from "./Reveal";
import { WhatsAppIcon } from "./icons";

export const LoanProducts = () => (
  <section id="loans" className="py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14 lg:mb-20">
        <div>
          <Eyebrow>01 — Our Loans</Eyebrow>
          <h2 className="mt-4 font-display font-medium text-4xl sm:text-5xl tracking-tight text-ink">
            Har sapne ke liye,
            <br />
            ek <em className="italic text-brand">loan</em> ready.
          </h2>
        </div>
        <p className="max-w-sm text-slate-600 leading-relaxed">
          Ghar, business, personal zaroorat ya padhai — chaar loans, ek simple
          process aur sirf ek phone call door.
        </p>
      </Reveal>

      <div className="grid sm:grid-cols-2 gap-6 sm:gap-8">
        {LOANS.map((loan, i) => (
          <Reveal key={loan.id} delay={(i % 2) * 0.12}>
            <article
              data-testid={`loan-card-${loan.id}`}
              className="group h-full bg-white rounded-[1.75rem] border border-black/5 overflow-hidden shadow-sm hover:shadow-xl hover:shadow-ink/10 transition-all duration-500 hover:-translate-y-1.5"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={loan.image}
                  alt={`${loan.title} — Satyam Financial`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent" />
                <span className="absolute top-4 left-4 rounded-full bg-white/90 backdrop-blur px-4 py-1.5 font-mono text-xs font-semibold text-ink">
                  {loan.rate} p.a.
                </span>
                <span className="absolute bottom-4 left-4 font-display text-3xl text-white font-medium">
                  {loan.title}
                </span>
              </div>

              <div className="p-6 sm:p-8">
                <p className="text-slate-600 leading-relaxed">{loan.tagline}</p>

                <div className="mt-5 grid grid-cols-2 gap-3 text-sm">
                  <div className="rounded-xl bg-tint px-4 py-3">
                    <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">
                      Tenure
                    </p>
                    <p className="mt-0.5 font-semibold text-ink">{loan.tenure}</p>
                  </div>
                  <div className="rounded-xl bg-tint px-4 py-3">
                    <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">
                      Extra
                    </p>
                    <p className="mt-0.5 font-semibold text-ink">{loan.extra}</p>
                  </div>
                </div>

                <ul className="mt-5 space-y-2.5">
                  {loan.highlights.map((h) => (
                    <li key={h} className="flex items-start gap-2.5 text-sm text-slate-600">
                      <span className="mt-0.5 grid place-items-center w-4.5 h-4.5 w-[18px] h-[18px] rounded-full bg-brand-light text-brand">
                        <Check className="w-3 h-3" strokeWidth={3} />
                      </span>
                      {h}
                    </li>
                  ))}
                </ul>

                <div className="mt-6 flex gap-3">
                  <a
                    data-testid={`loan-card-call-${loan.id}`}
                    href={TEL_LINK}
                    className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-ink text-white px-4 py-3 text-sm font-semibold hover:bg-brand transition-colors"
                  >
                    <Phone className="w-4 h-4" />
                    Call to Apply
                  </a>
                  <a
                    data-testid={`loan-card-whatsapp-${loan.id}`}
                    href={WA_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 rounded-full border border-brand/25 text-brand-dark px-5 py-3 text-sm font-semibold hover:bg-wa hover:text-white hover:border-wa transition-colors"
                  >
                    <WhatsAppIcon className="w-4 h-4" />
                    Details
                  </a>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-10">
        <p className="text-center text-xs text-slate-400 font-mono">
          *Interest rates indicative hain — final rate lender, profile aur loan
          amount par depend karta hai.
        </p>
      </Reveal>
    </div>
  </section>
);
